import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TesteService {
  private showEmpresasSource = new BehaviorSubject<boolean>(false);
  showEmpresas$ = this.showEmpresasSource.asObservable();

  constructor() {}

  toggleShowEmpresas() {
    this.showEmpresasSource.next(!this.showEmpresasSource.value);
  }
}
